<script>
import { store } from './store.js'

export default {
  components: {
  },
  data() {
    return {
      store
    }
  },
  mounted() {

  },
  watch: {
    
  },
  methods: {
    maxid() {
      if ( store.domelements.length == 0 )
        return 0;
      else
        return Math.max.apply(Math, store.domelements.map(function(o) { return o.id; })) + 1;
    },

    createrect() {
      var newid = this.maxid();
      store.domelements.push(
        {
          "id": newid,
          "idstr": 'ogpaintitem' + this.maxid(),
          "type": "rect",
          "layername": "Rectangle",
          "frame": { translatex : 0, translatey: 0, rotate: 0, width: 300, height: 200}, 
          "bgcolor": "#ffffff",
          "bgopacity": "100",
          "borderstyle": "solid",
          "borderwidth": "0",
          "bordercolor": "#000000",
          "borderradius": "0",
          "basicouterclass":"ogrect",
          "basicinnerclass":"ogrectinner",
          "innerclass":"",
          "outerclass":"",
        }
      );
      store.targetid = newid;
      jQuery( '#title' ).blur();
    },

    createtext() {
      var newid = this.maxid();
      store.domelements.push(
        {
          "id": newid,
          "idstr": 'ogpaintitem' + this.maxid(),
          "type": "text",
          "layername": "Text",
          "frame": { translatex : 0, translatey: 0, rotate: 0, width: 300, height: 200}, 
          "caption": "Add caption here",
          "color": "#000000",
          "opacity": "100",
          "fontsize": "40",
          "fontstyle": "normal",
          "lineheight": "1.4",
          "fontweight": "400",
          "fontfamily": "Open+Sans",
          "texttransform": "none",
          "verticalalign": "start",
          "horizontalalign": "left",
          "basicouterclass":"og-text",
          "basicinnerclass":"og-text-inner",
          "decorationline": [],
          "decorationthickness": "2",
          "decorationstyle": "solid",
          "decorationcolor": "#000000",
          "hshadow": "0",
          "vshadow": "0",
          "radiusshadow": "0",
          "colorshadow": "#000000",
          "opacityshadow": "100",
          "bgcolor": "#ffffff",
          "bgopacity": "0",
          "borderstyle": "solid",
          "borderwidth": "0",
          "bordercolor": "#000000",
          "borderradius": "0",
          "horizontalpadding": "0",
          "verticalpadding": "0",
          "innerclass":"",
          "outerclass":"",
        }
      );
     store.targetid = newid;
     jQuery( '#title' ).blur();
    },

     creatimg() {
       var newid = this.maxid();
      store.domelements.push(
        {
          "id": newid,
          "idstr": 'ogpaintitem' + this.maxid(),
          "type": "image",
          "layername": "Image",
          "frame": { translatex : 0, translatey: 0, rotate: 0, width: 300, height: 200}, 
          "src" : opengraphiqJS.pluginfolder + "og-static-image.png",
          "imgid" : "",
          "borderstyle": "solid",
          "borderwidth": "0",
          "bordercolor": "#000000",
          "borderradius": "0",
          "basicouterclass":"og-img",
          "basicinnerclass":"og-img-inner",
          "innerclass":"",
          "outerclass":"",
        }
      );
      store.targetid = newid;
      jQuery( '#title' ).blur();
    },

    createdynimg() {
      var newid = this.maxid();
      store.domelements.push(
        {
          "id": newid,
          "idstr": 'ogpaintitem' + this.maxid(),
          "type": "dynimage",
          "layername": "Featured image",
          "frame": { translatex : 0, translatey: 0, rotate: 0, width: 300, height: 200},
          "dynsrc": "featuredimage", 
          "backgroundimage": opengraphiqJS.pluginfolder + "og-dynamic-image.jpg",
          "imgid" : "",
          "borderstyle": "solid",
          "borderwidth": "0",
          "bordercolor": "#000000",
          "borderradius": "0",
          "basicouterclass":"og-dyn-img",
          "basicinnerclass":"og-dyn-img-inner",
          "innerclass":"",
          "outerclass":"",
        }
      );
      store.targetid = newid;
      jQuery( '#title' ).blur();
    },

    createdyntext() {
      var newid = this.maxid();
      store.domelements.push(
        {
          "id" : newid,
          "idstr": 'ogpaintitem' + this.maxid(),
          "type": "dyntext",
          "layername": "Post Title",
          "frame": { translatex : 0, translatey: 0, rotate: 0, width: 300, height: 200}, 
          "dyncaption": "title",
          "caption": "Dynamic Text",
          "metafield": "",
          "color": "#000000",
          "opacity": "100",
          "fontsize": "40",
          "fontstyle": "normal",
          "lineheight": "1.4",
          "fontweight": "400",
          "fontfamily": "Open+Sans",
          "texttransform": "none",
          "verticalalign": "start",
          "horizontalalign": "left",
          "basicouterclass":"og-text",
          "basicinnerclass":"og-text-inner",
          "decorationline": [],
          "decorationthickness": "2",
          "decorationstyle": "solid",
          "decorationcolor": "#000000",
          "hshadow": "0",
          "vshadow": "0",
          "radiusshadow": "0",
          "colorshadow": "#000000",
          "opacityshadow": "100",
          "bgcolor": "#ffffff",
          "bgopacity": "0",
          "borderstyle": "solid",
          "borderwidth": "0",
          "bordercolor": "#000000",
          "borderradius": "0",
          "horizontalpadding": "0",
          "verticalpadding": "0",
          "basicouterclass":"og-dyn-text",
          "basicinnerclass":"og-dyn-text-inner",
          "innerclass":"",
          "outerclass":"",
        }
      );
      store.targetid = newid;
      jQuery( '#title' ).blur();
    },

    createtaxonomy() {
      var newid = this.maxid();
      store.domelements.push(
        {
          "id" : newid,
          "idstr": 'ogpaintitem' + this.maxid(),
          "type": "taxonomy",
          "layername": "Categories",
          "frame": { translatex : 0, translatey: 0, rotate: 0, width: 300, height: 200}, 
          "dyncaption": "categories",
          "dynarray": ["category 1", "category 2"],
          "color": "#000000",
          "opacity": "100",
          "fontsize": "16",
          "fontstyle": "normal",
          "lineheight": "1.4",
          "fontweight": "400",
          "fontfamily": "Open+Sans",
          "texttransform": "none",
          "verticalalign": "start",
          "horizontalalign": "left",
          "basicouterclass":"og-text",
          "basicinnerclass":"og-text-inner",
          "decorationline": [],
          "decorationthickness": "2",
          "decorationstyle": "solid",
          "decorationcolor": "#000000",
          "hshadow": "0",
          "vshadow": "0",
          "radiusshadow": "0",
          "colorshadow": "#000000",
          "opacityshadow": "100",
          "bgcolor": "#ffffff",
          "bgopacity": "0",
          "borderstyle": "solid",
          "borderwidth": "0",
          "bordercolor": "#000000",
          "borderradius": "0",
          "horizontalpadding": "0",
          "verticalpadding": "0",
          "itemcontent": ",",
          "itembgcolor": "#ffffff",
          "itembgopacity": "0",
          "itempaddingleft": "5",
          "itempaddingright": "5",
          "itemborderradius": "0",
          "basicouterclass":"og-taxonomy",
          "basicinnerclass":"og-taxonomy-inner",
          "innerclass":"",
          "outerclass":"",
        }
      );
      store.targetid = newid;
      jQuery( '#title' ).blur();
    },

  },
};
</script>

<template>

  <div id="buttons" class="og-buttons">
    <button @mousedown.prevent="createtext()" @click.prevent="" id="textbutton" class="button button-secondary button-large dashicons-before dashicons-text">Add text</button>
    <button @mousedown.prevent="createdyntext()" @click.prevent="" id="dyntextbutton" class="button button-secondary button-large dashicons-before dashicons-text">Add dynamic text</button>
    <button @mousedown.prevent="createtaxonomy()" @click.prevent="" id="taxonomybutton" class="button button-secondary button-large dashicons-before dashicons-text">Add taxonomy</button>
    <button @mousedown.prevent="creatimg()" @click.prevent="" id="imgbutton" class="button button-secondary button-large dashicons-before dashicons-format-image">Add image</button>
    <button @mousedown.prevent="createdynimg()" @click.prevent="" id="dynimgbutton" class="button button-secondary button-large dashicons-before dashicons-format-gallery">Add dynamic image</button>
    <button @mousedown.prevent="createrect()" @click.prevent="" id="rectbutton" class="button button-secondary button-large dashicons-before dashicons-admin-page">Add rectangle</button>
  </div>

</template> 